import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { TMarketYoyGrowthExpectationMarket } from '../../api/types'

export type { TGrowthField } from '../../model/types'

export interface IGrowthValueRange {
  min: number
  max: number
}

/**
 * `number` — the single shared value; `IGrowthValueRange` — aggregated
 * records differ, carrying their min/max spread; `null` — no data ("—").
 */
export type TGrowthValue = number | IGrowthValueRange | null

export const isGrowthValueRange = (value: TGrowthValue): value is IGrowthValueRange =>
  value !== null && typeof value === 'object'

export interface IGrowthValues {
  yoyGrowth: TGrowthValue
  sobYoyGrowth: TGrowthValue
}

export type TGrowthValuesByMarket = Partial<
  Record<TMarketYoyGrowthExpectationMarket, IGrowthValues>
>

export interface IMarketYoyGrowthExpectationGroupRow {
  type: 'group'
  uid: string
  offering: ProgramTypes
  offeringTranslationKey: string
  ww: IGrowthValues
  byMarket: TGrowthValuesByMarket
}

export interface IMarketYoyGrowthExpectationItemRow {
  type: 'item'
  uid: string
  offering: ProgramTypes
  productCategory: string
  ww: IGrowthValues
  byMarket: TGrowthValuesByMarket
}

export type TMarketYoyGrowthExpectationTableRow =
  | IMarketYoyGrowthExpectationGroupRow
  | IMarketYoyGrowthExpectationItemRow

export interface IMarketYoyGrowthExpectationGroup {
  group: IMarketYoyGrowthExpectationGroupRow
  items: IMarketYoyGrowthExpectationItemRow[]
}
